const ReviewData = [
	{
		id: 'a1',
		name: 'Oliver',
		city: 'Santa Maria',
		state: 'CA',
		title: 'Honest and Fair Master Technician',
		feedback:
			'After years of hard work I had managed to save up enough money to buy an Audi and , sure enough, while driving it with a friend it started to shake and lose power.  I instantly decided that I had to take action and called Andrew, he arrived at my house within 45 minutes and he diagnosed it as a misfire.  All I had to do was buy new spark plugs and coils, and my car was driving good as new! I saved a ton of money, because had I taken it to the dealer it would have cost me an arm and a leg!  It was so easy and cost effective that I had to recommended him to all of my friends and family.'
	},
	{
		id: 'a2',
		name: 'Michelle',
		city: 'Santa Maria',
		state: 'CA',
		title: 'I Saved a lot of Money and Did Not Leave My House.',
		feedback:
			'One day before going to work my car decided to not start 🤦🏽‍♀️.  My husband was at work and I could not afford to tow it to a shop, so I decided to take my friends advice and call the mobile mechanic.  I thought I was going to have to call in sick, but Andrew got my car up and running in just 1-2 hours.  I dont understand much about cars, but he explained to me that all we needed to do was replace the starter. He called Autozone and luckily they had the starter for my car in stock, so he picked it up and simply installed it.  Before I knew it, my car was up and running and my stressful day was behind me! Whenever somebody I know needs some auto work I always recommend Andrew to them, it was a 10/10 experience 👏🏽👏🏽👏🏽'
	},
	{
		id: 'a4',
		name: 'Roxy',
		city: 'Santa Maria',
		state: 'CA',
		title: 'Look No Further',
		feedback:
			"Yesterday I ran into some car trouble and had to do something, so I decided to try out a local mobile mechanic.  He was able to replace my alternator faster and cheaper than what I would have had to deal with had I gone to the dealer.  I can't complain about the service, he is a top notch mechanic who knows a lot and charges a fair price."
	},
	{
		id: 'a3',
		name: 'Rick',
		city: 'Santa Maria',
		state: 'CA',
		title: 'Great Value',
		feedback:
			"I'm not much of a car guy and my Honda Accord has been a very reliable daily driver, but ,as I learned, every car needs some form of maintenance.  I had been putting off getting some maintenance work on it for months and decided that it was time for a professional to come and take a look at it.  Mr. Ramirez performed full-service maintenance on my Honda and recharged my car's air conditioning system...I could have not been any happier with the job.  He has decades of experience working on pretty much any type of car, just by being around him for a little while I learned a lot of valuable information in regards to car maintenance.  "
	}
];

export default ReviewData;
